import Analytics from '@module/analytics';

class ClickTracker {
  constructor(config) {
    this.body = config.body;
    this.handlers = this.generateHandlers(config.track);
    this.page = config.page;
  }

  attach = () => {
    this.handlers.forEach((h) => h.attach());
  };

  remove = () => {
    this.handlers.forEach((h) => h.remove());
  };

  generateHandlers = (settings) => {
    return settings.map((setting) => {
      return this.setHandler(setting);
    });
  };

  setHandler = (settings) => {
    const handler = (event) => {
      event.stopImmediatePropagation();
      Analytics.trackStructEvent({
        category: this.page,
        action: settings.action,
        label: settings.label,
      });
    };

    const element = this.body.node.querySelector(settings.selector);

    // If element doesn't exists we keep the object structure with function that doesn't do anything as a temp fix
    // TODO @Helen look into a better fix and spec coverage
    if (!element) {
      const obj = {
        attach: () => {
          // do nothing
        },
        remove: () => {
          // do nothing
        },
      };

      return obj;
    }

    return {
      attach: () => {
        element.addEventListener('click', handler);
      },
      remove: () => {
        element.removeEventListener('click', handler);
      },
    };
  };
}

export default ClickTracker;
